import { CADENCE_STEPS } from './leadConstants';

// Outreach cadence is guidance only (no auto-send). Logging a visit advances the
// lead one step along CADENCE_STEPS so the drawer's "Suggested next" moves on its
// own. Capped at the last step so it never runs off the end (T-U3-004).
export function advanceCadence(step) {
  const cur = Number.isInteger(step) ? step : 0;
  return Math.min(cur + 1, CADENCE_STEPS.length - 1);
}

// "No touch 14+d" chip predicate (T-U3-006): a lead with no recorded touch, or
// whose last touch was more than 14 days ago.
export const NO_TOUCH_MS = 14 * 864e5;
export function isNoTouch14d(lastTouchAt, now = Date.now()) {
  if (!lastTouchAt) return true;
  return now - lastTouchAt > NO_TOUCH_MS;
}
